module.exports = __webpack_public_path__ + "static/media/NoelM.640a7ae3.jpg";